import React from 'react'
import tw, { styled } from 'twin.macro'
import { useQuestionStep } from 'context/QuestionStepContext'
import Button from 'components/Button'

const Root = styled.div`
  ${tw`bg-gradient-to-r from-green-300 to-blue-500 w-full h-full p-xl text-white`}
`

const Title = styled.div`
  ${tw`text-5xl sm:text-8xl font-extralight pb-xl`};
`

const TextBox = styled.div`
  ${tw`mb-15 sm:mb-0 whitespace-nowrap`}
`

const BoldText = styled.span`
  ${tw`font-bold`}
`

const Landing = () => {
  const { goToNextStep } = useQuestionStep()
  return (
    <Root>
      <Title>
        <TextBox>
          <BoldText>나</BoldText>를
        </TextBox>
        <TextBox>
          <BoldText>도시</BoldText>로
        </TextBox>
        <TextBox>
          <BoldText>표현</BoldText>한다면?
        </TextBox>
      </Title>
      <Button
        onClick={goToNextStep}
        message="나랑 찰떡궁합 도시 알아보기 😘"
      ></Button>
    </Root>
  )
}

export default Landing
